<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import configShare from '@/utils/wxShare'

export default {
  name: 'App',
  mounted () {
    // 微信公众号全局分享配置（发送给朋友 / 分享到朋友圈）
    configShare()
  }
}
</script>

<style lang="less">
  html,body{
    margin: 0;padding: 0;
    height: 100%;
    /* 白色背景：防止部分手机内容不足时露出系统黑色/深色底色 */
    background: #ffffff;
  }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
